/* ═══════════════════════════════════════════════════
   NV – CTA Group · Download handler
   Auto-init su tutti i .nv-cta-group-block
   ═══════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* Guard: evita doppia inizializzazione se lo script viene incluso più volte */
  if (window.__nvCtaGroupLoaded) return;
  window.__nvCtaGroupLoaded = true;

  /* ─── Rilevamento piattaforma (una volta sola) ─── */
  var ua = navigator.userAgent || '';

  var isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  var isMacSafari =
    !isIOS &&
    /Macintosh/.test(ua) &&
    /Safari/.test(ua) &&
    !/Chrome|Chromium|Edg|OPR|Opera|Brave|Firefox/.test(ua);

  var isAndroid = /Android/i.test(ua);
  var isSamsungBrowser = /SamsungBrowser/i.test(ua);

  /* Browser in-app: Facebook, Instagram, WhatsApp, TikTok, Telegram, LinkedIn, ecc. */
  var isInAppBrowser =
    /FBAN|FBAV|Instagram|Line\/|WhatsApp|Snapchat|Twitter|MicroMessenger|WeChat|TikTok|BytedanceWebview|LinkedInApp|GSA\/|Telegram/i.test(
      ua
    );

  /* Feature detection */
  var hasFetch = typeof window.fetch === 'function';
  var hasBlob =
    typeof window.Blob === 'function' &&
    typeof window.URL !== 'undefined' &&
    typeof window.URL.createObjectURL === 'function';

  /* ─── Helper: estrai nome file dall'URL ─── */
  function extractFilename(url, fallbackName) {
    try {
      var pathname = new URL(url).pathname;
      var lastSegment = pathname.split('/').pop();
      if (lastSegment && lastSegment.includes('.'))
        return decodeURIComponent(lastSegment);
    } catch (e) {
      /* ignore */
    }
    if (fallbackName && !fallbackName.includes('.')) {
      return fallbackName + '.pdf';
    }
    return fallbackName || 'download.pdf';
  }

  /* ─── Strategia 1: Blob download (Desktop Chrome/Edge/Firefox/Brave, Android) ─── */
  function blobDownload(blob, filename) {
    var blobUrl = window.URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    setTimeout(function () {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    }, 500);
  }

  /* ─── Strategia 2: iOS Web Share API (iOS 15+) ─── */
  function iosShareDownload(blob, filename, onFail) {
    if (!navigator.share || typeof File === 'undefined') {
      onFail();
      return;
    }
    try {
      var file = new File([blob], filename, {
        type: blob.type || 'application/octet-stream',
      });
      if (navigator.canShare && !navigator.canShare({ files: [file] })) {
        onFail();
        return;
      }
      navigator.share({ files: [file] }).catch(function () {
        /* utente ha annullato — ok */
      });
    } catch (e) {
      onFail();
    }
  }

  /* ─── Strategia 3: iOS blob viewer ─── */
  function iosBlobViewer(blob) {
    var blobUrl = window.URL.createObjectURL(blob);
    window.location.href = blobUrl;
    setTimeout(function () {
      window.URL.revokeObjectURL(blobUrl);
    }, 120000);
  }

  /* ─── Strategia 4: navigazione diretta (ultimo fallback) ─── */
  function directNavigation(url) {
    window.location.href = url;
  }

  /* ─── Orchestratore download per piattaforma ─── */
  function triggerDownload(blob, filename, originalUrl) {
    if (isInAppBrowser) {
      directNavigation(originalUrl);
      return;
    }
    if (isIOS) {
      iosShareDownload(blob, filename, function () {
        iosBlobViewer(blob);
      });
      return;
    }
    if (isMacSafari || isSamsungBrowser || isAndroid) {
      blobDownload(blob, filename);
      return;
    }
    /* Desktop Chrome, Edge, Firefox, Brave, Opera */
    blobDownload(blob, filename);
  }

  /* ─── Fallback quando fetch fallisce (CORS, rete, timeout) ─── */
  function fallbackDownload(url, filename) {
    if (isInAppBrowser || isIOS || isMacSafari) {
      directNavigation(url);
      return;
    }
    var link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    setTimeout(function () {
      document.body.removeChild(link);
    }, 500);
  }

  /* ─── Init singolo container ─── */
  function initCtaGroup(container) {
    if (container.dataset.nvCtaInit) return;
    container.dataset.nvCtaInit = '1';

    container
      .querySelectorAll('a[data-force-download="true"]')
      .forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          /* Download gia' in corso (doppio clic o doppio Invio): si ignora il
             secondo clic, altrimenti salverebbe lo spinner come contenuto
             "originale" e il pulsante resterebbe per sempre senza testo. */
          if (btn.classList.contains('is-loading')) return;

          var url = this.href;
          var filename = extractFilename(url, this.dataset.filename);
          var originalHTML = btn.innerHTML;

          btn.innerHTML = '<span class="nv-spinner"></span>';
          btn.classList.add('is-loading');

          function restoreBtn() {
            btn.innerHTML = originalHTML;
            btn.classList.remove('is-loading');
          }

          /* In-app browser: skip fetch, vai diretto */
          if (isInAppBrowser) {
            directNavigation(url);
            restoreBtn();
            return;
          }

          /* Browser senza fetch/Blob */
          if (!hasFetch || !hasBlob) {
            fallbackDownload(url, filename);
            restoreBtn();
            return;
          }

          /* Fetch con timeout (30 s) */
          var aborted = false;
          var controller = null;
          var fetchOptions = { mode: 'cors', credentials: 'omit' };

          if (typeof AbortController !== 'undefined') {
            controller = new AbortController();
            fetchOptions.signal = controller.signal;
            setTimeout(function () {
              if (!aborted) {
                aborted = true;
                controller.abort();
              }
            }, 30000);
          }

          fetch(url, fetchOptions)
            .then(function (response) {
              if (!response.ok) throw new Error('HTTP ' + response.status);
              return response.blob();
            })
            .then(function (blob) {
              aborted = true;
              triggerDownload(blob, filename, url);
              restoreBtn();
            })
            .catch(function (err) {
              aborted = true;
              var isTimeout = err.name === 'AbortError';
              console.warn(
                'NV CTA download –',
                isTimeout ? 'timeout' : 'fetch failed',
                err
              );
              fallbackDownload(url, filename);
              restoreBtn();
            });
        });
      });
  }

  /* ─── Init globale ─── */
  function initAll(scope) {
    (scope || document)
      .querySelectorAll('.nv-cta-group-block')
      .forEach(initCtaGroup);
  }

  /* Primo caricamento */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Shopify theme editor: ri-inizializza quando una sezione viene caricata/rimossa */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
